const value = 'Human Factor, LLC ';

export default value;
